import Connection from "../Connection/Connection";

export default function DailyConnection() {
  return <Connection id={"daily"}></Connection>;
}
